
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/marine-and-energy-insurance",
      function () {
        return require("private-next-pages/solutions/marine-and-energy-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/marine-and-energy-insurance"])
      });
    }
  